// Externals
import { createPortal } from "react-dom";
import React, { useEffect, useState, useRef } from "react";

// Scss
import "./InfoButton.scss";

// Assets
import InfoIcon from "../static/svg/info2.svg";
import TimesIcon from "../static/svg/times.svg";

const Portal = ({ children }) => {
	const [container] = useState(() => {
		const el = document.createElement("div");
		return el;
	});

	useEffect(() => {
		document.querySelector("#popUpWindow").appendChild(container);
		return () => {
			document.querySelector("#popUpWindow").removeChild(container);
		};
	}, [container]);

	return createPortal(children, container);
};

const InfoButton = ({ information, open, onToggle, isHTML, html, style }) => {
	const ImageTextIcon = useRef(null);

	useEffect(() => {
		const handleEsc = (event) => {
			if (event.keyCode === 27) {
				if (open === true) {
					onToggle();
				}
			}
		};

		const handleClick = () => {
			if (open === true) {
				// onToggle();
			}
		};
		window.addEventListener("keydown", handleEsc);
		const ImageTextIconCurrent = ImageTextIcon.current;

		if (ImageTextIconCurrent) {
			// ImageTextIconCurrent.addEventListener("click", handleClick);
		}

		return () => {
			window.removeEventListener("keydown", handleEsc);
			if (ImageTextIconCurrent) {
				ImageTextIconCurrent.removeEventListener("click", handleClick);
			}
		};
	}, [onToggle, open, ImageTextIcon]);

	return (
		<>
			<img
				className="infoIcon"
				onClick={onToggle}
				src={InfoIcon}
				alt="info"
				style={style}
			/>

			{open && (
				<Portal>
					<div className="modal_content" onClick={onToggle}>
						<div className="wrapper">
							{isHTML === false ? (
								<>
									<div
										dangerouslySetInnerHTML={{
											__html: information,
										}}
									/>
								</>
							) : (
								<>
									<div>{html}</div>
								</>
							)}

							<img
								ref={ImageTextIcon}
								className="times-icon"
								src={TimesIcon}
								alt="times-icon"
							/>
						</div>
					</div>
				</Portal>
			)}
		</>
	);
};

export default InfoButton;
